import {
  SimpleHeader,
  SimpleHeaderWithNavigation,
} from '@/features/shared/components/Headers/SimpleHeader'
import { type NextPageWithLayout } from '@/pages/_app'

export function withSimpleHeaderLayout<P>(Component: NextPageWithLayout<P>) {
  Component.getHeaderLayout = (page) => (
    <>
      <SimpleHeader />
      {page}
    </>
  )
  return Component
}

export function withSimpleHeaderWithNavigationLayout<P>(
  Component: NextPageWithLayout<P>
) {
  Component.getHeaderLayout = (page) => (
    <>
      <SimpleHeaderWithNavigation />
      {page}
    </>
  )
  return Component
}
